<template lang="pug">
#outing-setting.box(v-cloak)
  .box-header.register-header.with-border
    .d-flex.justify-content-start.align-items-center
      .d-flex.justify-content-start.flex-column
        .title
          span 外出外泊届けの基本設定
  .box-body.register-body
    .register-body(v-if="setting")
      //- 受付状態（外出届け）
      FormInputRadio(v-model="setting.canApplication.goingOut" name="can-application-going-out" key-name="受付状態（外出届け）"
        :options="_canApplicationOptions" :validation-rules="{ required: true }" required)
        template(v-slot:question)
          HelpIcon(popoverId="can-application-going-out-help" title="受付状態（外出届け）について")
            template(v-slot:text)
              div 受付中にすると、家族ユーザーが外出届けを申請できます（管理システムからの代理届けも可能）。停止中の場合は外出届けを申請できません。
      //- 受付状態（外泊届け）
      FormInputRadio(v-model="setting.canApplication.stayingOut" name="can-application-staying-out" key-name="受付状態（外泊届け）"
        :options="_canApplicationOptions" :validation-rules="{ required: true }" required)
        template(v-slot:question)
          HelpIcon(popoverId="can-application-staying-out-help" title="受付状態（外泊届け）について")
            template(v-slot:text)
              div 受付中にすると、家族ユーザーが外泊届けを申請できます（管理システムからの代理届けも可能）。停止中の場合は外泊届けを申請できません。
      //- 外出外泊可能曜日（外泊はお迎え日と帰所日）
      InputOutingAvailableWeekDays(v-model="setting.outingAvailableWeekDay" name="outing-available-week-day")
        template(v-slot:question)
          HelpIcon(popoverId="outing-available-week-day-help" title="外出外泊可能曜日（外泊はお迎え日と帰所日）について")
            template(v-slot:text)
              div 外出もしくは外泊の開始（お迎え）と終了（帰所）ができる曜日を設定できます（祝日は考慮しません）。
      //- 外出外泊可能時間（外泊はお迎え時間と帰所時間）
      .register-row
        .register-group
          .register-key
            span.key-name 外出外泊可能時間（外泊はお迎え時間と帰所時間）
            span.validation-label 必須
            HelpIcon(popoverId="outing-available-time-help" title="外泊可能時間（外泊はお迎え時間と帰所時間）について")
              template(v-slot:text)
                div 外出もしくは外泊のお迎えと帰所が可能な時間を設定できます。対応可能な時間を選択してください。
          .register-value.mb-2(v-for="(time, index) in availableTimes")
            InputOutingAvailableTime(v-model="availableTimes[index]" :name="'outing-available-time' + index"
              @onDelete="onAvailableTimeDelete(index)" required)
          .buttons
            button.btn(@click="addAvailableTime" :class="{ 'disable': _disableAddAvailableTime }" :disabled="_disableAddAvailableTime") 追加
          .error-messages(v-for="error in errors.collect('outing-available-time')")
            label.error-message {{ error }}
              br

      //- 外泊最大泊数
      FormInput(v-model="setting.stayLimit" name="stay-limit" key-name="外泊最大泊数"
        type="number" :min="0" :max="13" unitText="泊" :styles="{ width: '80px' }"
        :validation-rules="{ required: true }" required)
        template(v-slot:question)
          HelpIcon(popoverId="stay-limit-help" title="外泊最大泊数について")
            template(v-slot:text)
              div 外泊の場合の最大の宿泊数を設定できます（最大で13泊の設定が可能）。
      //- 家族ユーザーの届出可能日
      FormInputRadio(v-model="setting.requestAvailableDate" name="request-available-date" key-name="家族ユーザーの届出可能日"
        :options="_requestAvailableDateOptions" :validation-rules="{ required: true }" required)
        template(v-slot:question)
          HelpIcon(popoverId="request-available-date-help" title="家族ユーザーの届出可能日について")
            template(v-slot:text)
              div 外出もしくは外泊日の何日前までの届出申請が可能かの設定ができます。
      //- 施設での食事の表示項目
      InputUseOutingNeedsMeal(v-model="setting.useNeedsMeal" name="use-needs-meal" key-name="施設での食事の表示項目")
        template(v-slot:question)
          HelpIcon(popoverId="use-needs-meal-help" title="施設での食事の表示項目について")
            template(v-slot:text)
              div
                span ご家族が外出外泊届けをする際に、施設での食事について「いる」「いらない」の選択ができます。
                span そこで選択する食事の項目を設定することができます。
                span （〇×をクリックすると切り替わります。）
                br
                strong 〇
                span ：項目を表示する
                br
                strong ×
                span ：項目を表示しない
      //- 外出手段の使用
      FormInputRadio(v-model="setting.useSelectedVehicle" name="use-selected-vehicle" key-name="外出手段の使用"
        :options="_useSelectedVehicleOptions" :validation-rules="{ required: true }" required)
        template(v-slot:question)
          HelpIcon(popoverId="use-selected-vehicle-help" title="外出手段の使用について")
            template(v-slot:text)
              div
                strong 使用しない
                span の場合、外出外泊届けに外出手段を表示しません。
                br
                strong 使用する
                span の場合、外出外泊届けに外出手段を表示し、次に設定する「家族等の車」などの選択肢を表示してご家族が選択できるようになります。
      //- 外出手段の選択肢
      InputUseVehicleOptions(v-show="setting.useSelectedVehicle" v-model="setting.useVehicleOptions" name="use-vehicle-options"
        key-name="外出手段の選択肢" :validation-rules="{ required: true }" required)
          template(v-slot:question)
            HelpIcon(popoverId="use-vehicle-options-help" title="外出手段の選択肢")
              template(v-slot:text)
                div
                  span 外出手段の選択肢として表示する項目を設定してください。チェックした項目が表示されます。
                  br
                  span なお、この選択肢以外に「その他（自由記述）」があります。
      //- 自動承諾
      FormInputRadio(v-model="setting.autoApproval" name="auto-approval" key-name="自動承諾"
        :options="_autoApprovalOptions" :validation-rules="{ required: true }" required)
        template(v-slot:question)
          HelpIcon(popoverId="auto-approval-help" title="自動承諾について")
            template(v-slot:text)
              div 家族ユーザーからの届出申請に対して自動で承諾するか、手動で承諾するかの設定ができます。
      //- 家族ユーザーへの連絡事項
      FormTextarea(v-model="setting.description" name="description" key-name="家族ユーザーへの連絡事項"
        placeholder="例：外出と外泊のお迎え日を月曜日から金曜日のみにさせていただいております。\n面会や他の外出外泊と時間がかぶっている場合は外出外泊届けができません。\n外出外泊届けは１週間前までに申請ください。"
        :validation-rules="{ max: 1000 }" :maxlength="1000" :styles="{ maxWidth: '700px', width: '700px', minHeight: '160px' }")
        template(v-slot:question)
          HelpIcon(popoverId="description-help" title="家族ユーザーへの連絡事項について")
            template(v-slot:text)
              div 家族ユーザーが届出申請するページに掲載する連絡事項を入力できます。
      //- 家族からの連絡事項の使用有無
      FormInputRadio(v-model="setting.useText" name="use-text" key-name="家族からの連絡事項の使用有無"
        :options="_useTextOptions" :validation-rules="{ required: true }" required)
        template(v-slot:question)
          HelpIcon(popoverId="use-text-help" title="家族からの連絡事項の使用有無について")
            template(v-slot:text)
              div 家族ユーザーが届出申請する際に入力できる連絡事項欄を使用するか否かの設定ができます。

    //- エラーメッセージ
    .register-row(v-show="errorMessage")
      .register-group
        .register-value
          .error-message {{ errorMessage }}

  .box-footer.register-footer
    ValidationAlert(v-model="showValidationAlert")
    .buttons.m-0
      button.btn.update-btn(@click="onUpdate" type="button") 更新
      button.btn.cancel-btn(@click="gotoOutingList" type="button") キャンセル

  //- 更新モーダル
  OkCancelModal(v-model="showUpdateModal" title="外出外泊届けの基本設定を更新しますか？" @ok="updateSetting(setting)")
  OkModal(v-model="showUpdateSuccessModal" title="更新に成功しました。" @ok="gotoOutingList")

  //- ページ全体ローディング
  PageLoading(:isBusy="isBusy" :message="loadingMessage")
</template>

<script lang="ts">
import { Component, Inject, Vue } from "vue-property-decorator";
import { userStore } from "@/store/store";
import { PcUrl } from "@/commons/constants/PcUrl";
import SystemError from "@/commons/models/SystemError";

import OutingSettingsService, { AvailableTime, OutingSettingGetModel, OutingSettingPatchModel, RequestAvailableDate } from "@/commons/services/OutingSettings";

import PageLoading from "@/pc/basics/PageLoading.vue";
import ValidationAlert from "@/pc/basics/ValidationAlertByValidator.vue";
import HelpIcon from "@/pc/basics/HelpIcon.vue";
import OkCancelModal from "@/pc/basics/OkCancelModal.vue";
import OkModal from "@/pc/basics/OkModal.vue";
import FormInputRadio from "@/pc/components/forms/FormInputRadio.vue";
import FormInput from "@/pc/components/forms/FormInput.vue";
import FormTextarea from "@/pc/components/forms/FormTextarea.vue";
import InputUseOutingNeedsMeal from "@/pc/components/outings/InputUseNeedsMeal.vue";
import InputUseVehicleOptions from "@/pc/components/outings/InputUseVehicleOptions.vue";
import InputOutingAvailableWeekDays from "@/pc/components/outings/InputOutingAvailableWeekDays.vue";
import InputOutingAvailableTime, { InputOutingAvailableTimeModel } from "@/pc/components/outings/InputOutingAvailableTime.vue";

/**
 * ### 外出外泊届け設定画面
 */
@Component({
  components: {
    PageLoading,
    ValidationAlert,
    HelpIcon,
    OkCancelModal,
    OkModal,
    InputOutingAvailableWeekDays,
    InputOutingAvailableTime,
    FormInputRadio,
    FormInput,
    FormTextarea,
    InputUseOutingNeedsMeal,
    InputUseVehicleOptions
  },
  $_veeValidate: { validator: "new" }
})
export default class OutingSetting extends Vue {
  /** 外出外泊サービス */
  @Inject("OutingSettingsService") outingSettingsService!: OutingSettingsService;

  /** ページ全体ローディング表示可否 */
  isBusy: boolean = false;
  /** ローディングメッセージ */
  loadingMessage: string = "";

  /** 更新確認モーダル表示可否 */
  showUpdateModal: boolean = false;
  /** 更新完了モーダル表示可否 */
  showUpdateSuccessModal: boolean = false;

  /** バリデーションアラート表示可否 */
  showValidationAlert: boolean = false;

  /** エラーメッセージ */
  errorMessage: string = "";

  /** 外出外泊届け設定 */
  setting: OutingSettingGetModel | null = null;
  /** 外出外泊可能日（外泊は開始日）の選択した曜日名 */
  selectedOutingAvailableWeekDays: Array<string> = [];

  /** 外出外泊可能時間（最大5） */
  availableTimes: Array<InputOutingAvailableTimeModel> = [];

  get _canApplicationOptions(): Array<{ value: boolean; label: string }> {
    return [
      { value: false, label: "停止中" },
      { value: true, label: "受付中" }
    ];
  }

  get _requestAvailableDateOptions(): Array<{ value: RequestAvailableDate; label: string }> {
    return [
      { value: RequestAvailableDate.TODAY, label: "当日可" },
      { value: RequestAvailableDate.NEXT_DAY, label: "前日まで" },
      { value: RequestAvailableDate.THREE_DAYS, label: "3日前まで" },
      { value: RequestAvailableDate.FIVE_DAYS, label: "5日前まで" },
      { value: RequestAvailableDate.ONE_WEEK, label: "1週間前まで" }
    ];
  }

  get _autoApprovalOptions(): Array<{ value: boolean; label: string }> {
    return [
      { value: false, label: "使用しない" },
      { value: true, label: "使用する" }
    ];
  }

  get _useTextOptions(): Array<{ value: boolean; label: string }> {
    return [
      { value: false, label: "使用しない" },
      { value: true, label: "使用する" }
    ];
  }

  get _useSelectedVehicleOptions(): Array<{ value: boolean; label: string }> {
    return [
      { value: false, label: "使用しない" },
      { value: true, label: "使用する" }
    ];
  }

  /**
   * ### vue lifecycle mounted
   */
  public async mounted(): Promise<void> {
    this.isBusy = true;
    this.loadingMessage = "読込み中...";

    await this.createView();

    this.isBusy = false;
    return;
  }

  /**
   * ### 画面表示情報を作成する
   */
  public async createView(): Promise<void> {
    const setting: OutingSettingGetModel = await this.getSetting();
    this.setting = setting;

    // 時間は取得した値をそのまま使用できないので変数に格納して使用する
    this.availableTimes = [];
    for (const time of setting.outingAvailableTimes) {
      const startTime = time.start ? time.start : "0000";
      const formatedStartTime: string = `${startTime.slice(0, 2)}:${startTime.slice(2, 4)}:00`;
      const endTime = time.end ? time.end : "0000";
      const formatedEndTime: string = `${endTime.slice(0, 2)}:${endTime.slice(2, 4)}:00`;

      this.availableTimes.push({
        baseStartTime: formatedStartTime,
        startTime: formatedStartTime,
        baseEndTime: formatedEndTime,
        endTime: formatedEndTime
      });
    }

    return;
  }

  /**
   * ### 外出外泊届け設定取得
   */
  public async getSetting(): Promise<OutingSettingGetModel> {
    const response: OutingSettingGetModel = await this.outingSettingsService.get(userStore);
    return response;
  }

  /** ### 外出外泊可能時間の選択肢の追加 */
  addAvailableTime(): void {
    if (!this.availableTimes) this.availableTimes = [];
    this.availableTimes.push({
      baseStartTime: "00:00:00",
      startTime: "00:00:00",
      baseEndTime: "00:00:00",
      endTime: "00:00:00"
    });
    return;
  }

  /**
   * ### 外出外泊可能時間の追加可否
   *
   * - 最大5個まで追加可能
   */
  get _disableAddAvailableTime(): boolean {
    if (!this.availableTimes) {
      return true;
    } else {
      if (this.availableTimes.length < 5) {
        return false;
      } else {
        return true;
      }
    }
  }

  /** ### 外出外泊時間の削除 */
  onAvailableTimeDelete(index: number): void {
    this.availableTimes.splice(index, 1);
    return;
  }

  /**
   * ### 更新ボタン押下イベント
   */
  public async onUpdate(): Promise<void> {
    const validationResult: boolean = await this.$validator.validateAll();
    const validOutingAvailableTime: boolean = this.validateOutingAvailableTime();
    if (validOutingAvailableTime && validationResult) {
      this.showValidationAlert = false;
      this.showUpdateModal = true;
    } else {
      this.showValidationAlert = true;
    }
    return;
  }

  /**
   * ### 外出外泊可能時間のバリデーション
   *
   * - 必須入力
   * - 開始時間が終了時間より前かどうか
   */
  public validateOutingAvailableTime(): boolean {
    this.$validator.errors.remove("outing-available-time");

    if (this.availableTimes.length < 1) {
      this.$validator.errors.add({ field: "outing-available-time", msg: "外出外泊可能時間（外泊はお迎え時間と帰所時間）は1つ以上必要です" });
      return false;
    }
    if (5 < this.availableTimes.length) {
      this.$validator.errors.add({ field: "outing-available-time", msg: "外出外泊可能時間（外泊はお迎え時間と帰所時間）は最大5個まで設定可能です" });
      return false;
    }

    for (const time of this.availableTimes) {
      if (!time.baseStartTime || !time.baseEndTime) {
        return false;
      }
      const startTime = Number(time.baseStartTime.replace(/:/g, ""));
      const endTime = Number(time.baseEndTime.replace(/:/g, ""));
      if (endTime < startTime) {
        this.$validator.errors.add({ field: "outing-available-time", msg: "開始時間が終了時間より未来です" });
        return false;
      }
    }

    return true;
  }

  /**
   * ### 外出外泊届けを更新する
   */
  public async updateSetting(setting: OutingSettingGetModel): Promise<void> {
    this.isBusy = true;
    this.loadingMessage = "更新中...";

    try {
      const requestBody: OutingSettingPatchModel = await this.createRequestBody(setting);
      await this.outingSettingsService.patch(userStore, requestBody);

      this.showUpdateSuccessModal = true;
    } catch (error) {
      const systemError: SystemError = error as SystemError;
      // ステータスコードが409の場合、他端末にて更新が行われているので、画面情報を再取得してから再入力を促す
      if (systemError.statusCode == 409) {
        await this.createView();
        this.errorMessage = "他の端末で更新されたか、表示している情報が古いために更新できませんでした。情報を再読み込みして、もう一度お試しください。";
      } else {
        throw error;
      }
    } finally {
      this.isBusy = false;
    }

    return;
  }

  /**
   * ### 施設更新パラメータ作成
   */
  public createRequestBody(setting: OutingSettingGetModel): OutingSettingPatchModel {
    // 外出外泊可能時間（開始）と（終了）はコンポーネントで保持している値を変換してリクエストする
    const outingAvailableTimes: Array<AvailableTime> = [];
    for (const time of this.availableTimes) {
      const splitedStartTime: string[] = time.baseStartTime!.split(":");
      const splitedEndTime: string[] = time.baseEndTime!.split(":");
      outingAvailableTimes.push({
        start: splitedStartTime[0] + splitedStartTime[1],
        end: splitedEndTime[0] + splitedEndTime[1]
      });
    }

    const requestBody: OutingSettingPatchModel = {
      /** 受付状態 */
      canApplication: setting.canApplication,
      /** 外泊可能日 */
      outingAvailableWeekDay: setting.outingAvailableWeekDay,
      /** 外出外泊可能時間（最大5） */
      outingAvailableTimes: outingAvailableTimes,
      /** 届出可能日 */
      requestAvailableDate: setting.requestAvailableDate,
      /** 宿泊最大泊数 */
      stayLimit: Number(setting.stayLimit),
      /** 施設での食事の使用有無 */
      useNeedsMeal: setting.useNeedsMeal,
      /** 外出手段の選択の使用有無 */
      useSelectedVehicle: setting.useSelectedVehicle,
      /** 外出手段の選択肢の使用有無 */
      useVehicleOptions: setting.useVehicleOptions,
      /** 自動承諾 */
      autoApproval: setting.autoApproval,
      /** 家族ユーザーへの案内（1000文字） */
      description: setting.description ? setting.description : "",
      /** 家族からの連絡事項の使用有無 */
      useText: setting.useText,

      /** レコード更新日 */
      updated: setting.updated
    };

    return requestBody;
  }

  /**
   * ### 外出外泊届け一覧へ遷移する
   */
  public gotoOutingList(): void {
    this.$router.push(PcUrl.OutingList);
    return;
  }
}
</script>

<style lang="scss" scoped>
#outing-setting {
  max-width: 820px;
  margin-left: auto;
  margin-right: auto;

  .box-header {
    .title {
      font-size: 22px;
      font-weight: bold;
    }
  }

  .update-btn,
  .cancel-btn {
    width: 120px;
  }
}
</style>
